import { isFileSystemFileEntry } from './isFileEntry';

/**
 * Get the File from a FileSystemEntry.
 * If the entry is a File, return it.
 * If the entry is a FileSystemFileEntry, return the file.
 * If the entry is a folder, return null.
 */
export async function getEntryFile(
  entry: File | FileSystemEntry,
): Promise<File | null> {
  return entry instanceof File
    ? entry
    : isFileSystemFileEntry(entry)
      ? new Promise<File>((resolve, reject) => {
          entry.file(resolve, reject);
        })
      : null;
}
